import { Icon, Popup } from 'semantic-ui-react';
import './CanvasToolbar.css';

/**
 * Get CSS style for the background preview circle
 */
const getBackgroundPreviewStyle = (background) => {
  if (!background) return { backgroundColor: '#FFFFFF' };

  switch (background.type) {
    case 'color':
      return { backgroundColor: background.color || '#FFFFFF' };
    case 'gradient':
      return { background: background.gradient };
    case 'image':
      return {
        backgroundImage: `url(${background.imageUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      };
    case 'preset':
      return background.preset?.style || { backgroundColor: '#FFFFFF' };
    default:
      return { backgroundColor: '#FFFFFF' };
  }
};

const CanvasToolbar = ({
  onPersonClick,
  onBackgroundClick,
  onClothingPanelToggle,
  onLookbookToggle,
  onCommunityToggle,
  onEarningsToggle,
  isLoggedIn,
  onLoginRequired,
  isPersonModalOpen,
  isBackgroundModalOpen,
  isClothingPanelActive,
  isLookbookActive,
  isCommunityActive,
  isEarningsActive,
  background,
}) => {
  const handleAction = (loggedInAction) => {
    if (!isLoggedIn && onLoginRequired) {
      onLoginRequired();
    } else {
      loggedInAction?.();
    }
  };

  return (
    <div className="canvas-toolbar">
      {/* Person -- matches "male" icon from Wearer Management modal */}
      <Popup
        trigger={
          <button
            className={`canvas-toolbar-btn ${isPersonModalOpen ? 'active' : ''}`}
            onClick={() => handleAction(onPersonClick)}
          >
            <Icon name="male" />
          </button>
        }
        content="Wearer"
        position="left center"
        size="mini"
        inverted
      />

      {/* Canvas background -- live preview circle */}
      <Popup
        trigger={
          <button
            className={`canvas-toolbar-btn ${isBackgroundModalOpen ? 'active' : ''}`}
            onClick={() => handleAction(onBackgroundClick)}
          >
            <div
              className="toolbar-bg-preview"
              style={getBackgroundPreviewStyle(background)}
            />
          </button>
        }
        content="Background"
        position="left center"
        size="mini"
        inverted
      />

      <div className="canvas-toolbar-divider" />

      {/* Clothing panel -- hanger icon */}
      <Popup
        trigger={
          <button
            className={`canvas-toolbar-btn ${isClothingPanelActive ? 'active' : ''}`}
            onClick={() => handleAction(onClothingPanelToggle)}
          >
            <svg width="16" height="16" viewBox="0 0 48 48" fill="none" className="toolbar-hanger-icon">
              <circle cx="24" cy="10" r="3" stroke="currentColor" strokeWidth="4" fill="none" />
              <path d="M24 13 L24 18 L6 34 L6 38 L42 38 L42 34 L24 18" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            </svg>
          </button>
        }
        content="Clothing"
        position="left center"
        size="mini"
        inverted
      />

      {/* Lookbook panel -- folder icon */}
      <Popup
        trigger={
          <button
            className={`canvas-toolbar-btn ${isLookbookActive ? 'active' : ''}`}
            onClick={() => handleAction(onLookbookToggle)}
          >
            <Icon name="folder open outline" />
          </button>
        }
        content="Lookbook"
        position="left center"
        size="mini"
        inverted
      />

      <div className="canvas-toolbar-divider" />

      {/* Explore -- search icon. A magnifier reads as "find something" where a
          globe only reads as "somewhere else"; the panel it opens leads with a
          search field. */}
      <Popup
        trigger={
          <button
            className={`canvas-toolbar-btn ${isCommunityActive ? 'active' : ''}`}
            onClick={() => handleAction(onCommunityToggle)}
          >
            <Icon name="search" />
          </button>
        }
        content="Explore"
        position="left center"
        size="mini"
        inverted
      />

      {/* Earnings -- star icon */}
      {/* Earnings -- wallet icon */}
      <Popup
        trigger={
          <button
            className={`canvas-toolbar-btn ${isEarningsActive ? 'active' : ''}`}
            onClick={() => handleAction(onEarningsToggle)}
          >
            <Icon name="credit card outline" />
          </button>
        }
        content="My Wallet"
        position="left center"
        size="mini"
        inverted
      />
    </div>
  );
};

export default CanvasToolbar;

